import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/custom/components/organisms/Product/FieldsView'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { dateFormatFrontOnlyDate, dateTimeFormatFunction } from '@/custom/common/components'
import moment from 'moment'

const ListingCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const { t } = useTranslation()

    const { getAllDynamicArray, dynamicValue, getDynamicTableValues } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])
    useEffect(() => {
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {
                    action: {
                        value: 1,
                        type: 'in',
                        field: 'df.view_page',
                    },
                    active: {
                        value: 1,
                        type: 'in',
                        field: 'df.active',
                    },
                },
            },
            'listingEditDynamic',
        )
    }, [])

    const optionFunc = (data) => {
        getDynamicTableValues(
            {
                page: 1,
                limit: 100,
                order: '',
                orderby: '',
                filters: {
                    user_id: {
                        value: data,
                        type: 'like',
                        field: 'ci.fundraiser_name,ci.fundraiser_id,ci.reg_number',
                    },
                },
                table: 'charity_info',
            },
            'charity_data',
        )
    }
    const custom = {
        charity_id: '',
    }

    function isValidDateDifference(startDate, endDate, minDays) {
        const timeDifference = endDate - startDate
        const daysDifference = timeDifference / (1000 * 60)
        return daysDifference >= minDays * 24 * 60 - 1
    }

    useEffect(() => {
        if (dynamicValue.from === 'listingEditDynamic') {
            if (dynamicValue.records) {
                let projectType = props?.data?.projectType
                let dynamicValueAssign = dynamicValue.records
                let allData = []
                dynamicValueAssign
                    .filter((data) => data.active === 1)
                    .map((item) => {
                        if (item.name == 'date_added') {
                            var today = new Date()
                            item.initialDefault = dateTimeFormatFunction(today)
                        }
                        if (item.name == 'date_closed') {
                            var future = new Date()
                            future.setDate(future.getDate() + 10)
                            item.initialDefault = dateTimeFormatFunction(future)
                        }
                        // if (item.name == 'meeting_datetime') {
                        //     var future = new Date()
                        //     future.setDate(future.getDate() + 17)
                        //     item.initialDefault = dateTimeFormatFunction(future)
                        // }
                        if (item.view_on && projectType) {
                            if (item.view_on.includes(projectType) || item.view_on.includes('10')) {
                                if (item.name === 'qty') {
                                    item.initialDefault = 1
                                    item.type = 'default'
                                } else if (item.name === 'sprice') {
                                    item.initialDefault = 10
                                } else if (item.name === 'rprice') {
                                    item.initialDefault = 10
                                } else if (item.type == 'uploadDropZone') {
                                    item.isCrop = true
                                    item.multiple = false
                                } else if (item.name === 'charity_id') {
                                    item.type = 'searchdrop'
                                    item.getAllOptions = optionFunc
                                    item.options = []
                                }
                                if (item.name === 'desc_proc') {
                                    item.config = {
                                        htmlSupport: {
                                            allow: [
                                                {
                                                    name: /.*/,
                                                    attributes: true,
                                                    classes: true,
                                                    styles: true,
                                                },
                                            ],
                                        },

                                        toolbar: [
                                            'heading',
                                            '|',
                                            'bold',
                                            'italic',
                                            'link',
                                            'bulletedList',
                                            'numberedList',
                                            '|',
                                            'indent',
                                            'outdent',
                                            '|',
                                            'blockquote',
                                            'mediaEmbed',
                                            'undo',
                                            'redo',
                                        ],
                                    }
                                }
                                allData.push(item)
                            }
                        } else {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                                item.type = 'default'
                            } else if (item.name === 'sprice') {
                                item.initialDefault = 10
                            } else if (item.name === 'rprice') {
                                item.initialDefault = 10
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                                item.multiple = false
                            } else if (item.name === 'charity_id') {
                                item.type = 'searchdrop'
                                item.getAllOptions = optionFunc
                                item.options = []
                            }
                            if (item.name === 'desc_proc') {
                                item.config = {
                                    htmlSupport: {
                                        allow: [
                                            {
                                                name: /.*/,
                                                attributes: true,
                                                classes: true,
                                                styles: true,
                                            },
                                        ],
                                    },
                                    toolbar: [
                                        'heading',
                                        '|',
                                        'bold',
                                        'italic',
                                        'link',
                                        'bulletedList',
                                        'numberedList',
                                        '|',
                                        'indent',
                                        'outdent',
                                        '|',
                                        'blockquote',
                                        'mediaEmbed',
                                        'undo',
                                        'redo',
                                    ],
                                }
                            }
                            allData.push(item)
                        }
                    })
                allData.push(
                    { name: 'market_status', value: 'draft', type: 'default', active: 1 },
                    { name: 'auctiontype', value: 'live', type: 'default', active: 1 },
                )
                setFieldValue(allData)
            }
        }
    }, [dynamicValue])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    const customValidation = {
        date_closed: Yup.date(t('Please enter valid Date!'))
            .transform((__, value) =>
                value && typeof value === 'string'
                    ? new Date(
                          moment(
                              value,
                              global.defaultDateTimeFormat
                                  ? global.defaultDateTimeFormat
                                  : 'MM-DD-YYYY h:mm a',
                          ).toDate(),
                      )
                    : new Date(moment(value).subtract(1, 'minutes')),
            )
            // .test(
            //     'min-date-difference',
            //     'The difference between start date and end date must be at least 10 days.',
            //     function (endDate) {
            //         const startDate = this.resolve(Yup.ref('date_added'))
            //         if (startDate && endDate) {
            //             return isValidDateDifference(startDate, endDate, 10)
            //         } else {
            //             return true
            //         }
            //     },
            // )
            .min(Yup.ref('date_added'), t('Should be greater than start Time'))
            .nullable()
            .typeError(t('Required!'))
            .required(t('Required!')),
        meeting_datetime: Yup.date(t('Please enter valid Date!'))
            .transform(
                (__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  value,
                                  global.defaultDateTimeFormat
                                      ? global.defaultDateTimeFormat
                                      : 'MM-DD-YYYY h:mm a',
                              ).toDate(),
                          )
                        : null,
                // new Date(moment(value).subtract(1, 'minutes')),
            )
            // .test(
            //     'min-date-difference',
            //     'The difference between end date and meeting date must be at least 7 days.',
            //     function (endDate) {
            //         const startDate = this.resolve(Yup.ref('date_closed'))
            //         if (startDate && endDate) {
            //             return isValidDateDifference(startDate, endDate, 7)
            //         } else {
            //             return true
            //         }
            //     },
            // )
            .min(Yup.ref('date_closed'), t('Should be greater than Auction End Time'))
            .nullable()
            .typeError(t('Required!')),
        // .required(t('Required!')),
        charity_id: Yup.string().required('Required(start typing to see options)'),
    }
    console.log(fieldValue, 'fffffffff=======')
    return (
        <>
            <FieldsView
                fieldValue={fieldValue}
                // populateValidation={true}
                data={props.data}
                function={props.function}
                additionalFieldUpdate={additionalFieldUpdate}
                FullScreenPopup={true}
                draftBtnActive={true}
                customInitialValues={custom}
                addModaltitle={'Add New Offer'}
                editModaltitle={props.title ? props.title : 'Edit Offer'}
                customValidation={customValidation}
                minEndDate={1}
            />
        </>
    )
}

export default ListingCommon
